import { render, staticRenderFns } from "./ImageEditor.vue?vue&type=template&id=10d60e7f&scoped=true"
import script from "./ImageEditor.vue?vue&type=script&lang=js"
export * from "./ImageEditor.vue?vue&type=script&lang=js"
import style0 from "./ImageEditor.vue?vue&type=style&index=0&id=10d60e7f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d60e7f",
  null
  
)

export default component.exports